<template>
  <div class="anketa-completion">

    <div class="completion">

      <span class="logo">
        <img src="@/assets/img/anketa/ostin-capsula-logo.svg">
      </span>

      <div class="title">
        Спасибо тебе!
        <span class="description">
          Наши стилисты узнали всё, что<br>необходимо, и скоро мы тебя удивим.
        </span>
      </div>

      <timer-button
          :text="button.text"
          :link="button.link">
      </timer-button>

      <div class="completion-footer" >
        <div v-if="subscribed == false" class="text">Включи push-уведомления, чтобы не пропустить</div>
        <div v-if="subscribed == false" class="switch">
          <div>
            <Switch
            v-model:checked="notifications"
            @toggle="notifications"
          />
          </div>
        </div>
      </div>

    </div>
  </div>

</template>

<script>

import {useHeaderStore} from '@/stores/header'
import anketaMixin from "@/mixins/anketaMixin";
import {useAnketaStore} from "@/stores/anketa";
import {ref} from "vue";
import bottomData from "@/data/anketa/bottomData";
import Switch from "@/components/UI/Switch";
import TimerButton from "@/components/UI/TimerButton";
import headerMixin from "@/mixins/headerMixin";
import PushNotifications from "@/components/Common/PushNotifications.vue";
import {useUserStore} from "@/stores/users";
import {mapState} from "pinia";
import appMixin from "@/mixins/appMixin";


export default {
  name: 'TopQuestionView',
  components: {PushNotifications, TimerButton, Switch},
  mixins: [headerMixin,appMixin],
  props: ['header'],
  setup() {
    const {setSubscribed} = useUserStore();
    const { setValue,getStepData,steps } = useAnketaStore();
    const notifications = ref(getStepData("Notifications"))
    const {setHeaderData} = useHeaderStore();
    return {
      setHeaderData, setValue,getStepData,steps,notifications, setSubscribed
    };
  },
  computed:{
    ...mapState(useUserStore,['subscribed'])
  },
  watch:{
    notifications(newVal){
      this.setValue('Notifications',newVal)
      this.setSubscribed(true)
    }
  },
  data() {
    return {
      title: "<span>Выбери, какой у тебя размер низа:</span>",
      button: {
        text: 'ОБРАЗЫ ДЛЯ ТЕБЯ СКОРО',
        link: 'anketa.completion',
      },
      data: bottomData,
      step_number: "step9",
    }
  }
}
</script>

<style lang="less">
@import '@/assets/less/completion.less';
</style>
